/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';


class ViewQuantityData extends Component {



    // isFloat(n) {
    //     return Number(n) === n && n % 1 !== 0;
    // }

    // checkQuantity = (val) => {
    //     var totalQty = Number(val);
    //     if (!this.isFloat(totalQty)) {
    //         return val;
    //     } else {
    //         return totalQty.toFixed(2);
    //     }
    // }

    checkQuantity = (val) => {
        var totalQty = Number(val);
        if (Number.isInteger(totalQty)) {
            // It is indeed a number
            return val;
        } else {
            return totalQty.toFixed(2);
        }
    }


    render() {
        const { title, data, isEdit } = this.props;

        return (
            <div className="col-12 sale-table">
                <h5 className="font mt-2 mt-md-4 d-flex">{title}
                    <div className={isEdit ? "ml-auto mr-1" : "d-none"}>
                        <a className="mr-1">
                            <i className="customic ic-daksh-edit" onClick={this.props.handleEdit}></i>
                        </a>
                        <a className="mr-1">
                            <i className="customic ic-daksh-add" onClick={this.props.handleAdd}>
                            </i>
                        </a>
                    </div>

                </h5>
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                {/* <th width="33%">Crop</th>
                                <th width="33%">Hybrid</th>
                                <th width="33%">Quantity</th> */}

                                <th width="30%">Crop</th>
                                <th width="30%">Hybrid</th>
                                <th width="20%">Quantity</th>
                                <th width="20%">Units</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data?.length ?
                                    data.map((item, i) => (
                                        <tr className="cursor-pointer" key={i}>
                                            <td>{item.crop_name}</td>
                                            <td>{item.hybrid_name}</td>
                                            {/* <td><b>{item.quantity}</b></td> */}
                                            <td><b>{this.checkQuantity(item.quantity)}</b></td>
                                            <td><b>{item?.weight_unit_name}</b></td>
                                        </tr>
                                    )) : null
                            }
                            {/* <tr className="cursor-pointer">
                                <td>Cotton</td>
                                <td>US 350</td>
                                <td><b>100</b></td>
                            </tr>
                            <tr className="cursor-pointer">
                                <td>Cotton</td>
                                <td>US 380</td>
                                <td><b>100</b></td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default ViewQuantityData;
